import { parse } from 'csv-parse/browser/esm/sync';

export function parseInvoiceExport(records: string, fileName: string) {
  // Pandas export returns Python specific types for JSON which cannot
  // be parsed by the browser, fix here.
  // csv-parse 7 types `parse` as `parse<T = unknown>(): T[]`, and nothing here
  // gives it a target to infer T from, so name the row shape explicitly —
  // `columns: true` yields one object per row keyed by header.
  const parsedRecords = parse<Record<string, string>>(records, {
    columns: true,
  });
  const fixedRecords = parsedRecords.map((record) => {
    if (record['PriceSummary']) {
      const fixedSummary = record['PriceSummary']
        .replace(/'/g, '"')
        .replace(/True/g, 'true')
        .replace(/False/g, 'false')
        .replace(/None/g, 'null');
      return {
        ...record,
        PriceSummary: fixedSummary,
      };
    }

    return record;
  });

  return {
    data: {
      records: fixedRecords,
      fileName: fileName.replace(/\.csv$/, ''),
    },
  };
}
